module.exports = __webpack_public_path__ + "static/media/sf_logo.391565bd.png";